import React, { useState } from "react";

const CareerModel = ({ modalData, closeModal }) => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    phone: "",
    workauthorization: "",
    resume: null,
  });

  // Handle form input change
  const handleChange = (e) => {
    const { id, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "file" ? files[0] : value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    const dataString = new FormData();
    
    // Append form fields to FormData
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        dataString.append(key, formData[key]);
      }
    });
  
    // API URL for posting the file
    const api = '/api/postFile';
    
    try {
      // Make the POST request using fetch
      const response = await fetch(api, {
        method: 'POST',
        headers: {
          enctype: 'multipart/form-data',
        },
        body: dataString,
      });
      
      if (!response.ok) {
        throw new Error('Failed to upload the file');
      }
      
      const res = await response.json();
      
      if (res.success === 1) {
        alert(res.message);
        window.location.reload(); // Or update the state as necessary
      } else {
        alert(res.message);
        window.location.reload();
      }
    } catch (error) {
      console.error('Error submitting the form:', error);
      alert('There was an error with the submission. Please try again.');
    }
  };

  return (
    <div className={`modal fade ${modalData ? "show d-block" : ""}`} tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Apply for the job</h5>
            <button type="button" className="close ml-auto" onClick={closeModal} aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="job_code">Job Code</label>
                <input
                  type="text"
                  className="form-control"
                  id="job_code"
                  value={modalData.jobCode + "(" + modalData.jobTitle + ")"}
                  readOnly
                />
                <input type="hidden" id="id"  name="id" value={modalData.jobId} />
              </div>
              <div className="form-group">
                <label htmlFor="fullname">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="workauthorization">Work Authorization</label>
                <select
                  className="form-control"
                  id="workauthorization"
                  value={formData.workauthorization}
                  onChange={handleChange}
                >
                  <option value="">--choose--</option>
                  {/* Add options dynamically */}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="resume">Resume</label>
                <input
                  type="file"
                  className="form-control"
                  id="resume"
                  accept=".doc,.docx,.pdf"
                  onChange={handleChange}
                />
              </div>
              <button type="submit" className="mt-3 btn btn-primary">
                Apply
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerModel;
